'use strict';

var FbcApplicabilityChartFilterFactory = function FbcApplicabilityChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FaresFilterByMarketFactory', 'FaresFilterByClassFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FbcApplicabilityChartFilter() {
    DemandFilter.call(this, 'fares-mode', ['fbc-applicability-chart', 'fares-fbc-usage-chart']);
    this.registerFilters(injectedFilters);
  }
  FbcApplicabilityChartFilter.prototype = Object.create(DemandFilter.prototype);
  FbcApplicabilityChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  return FbcApplicabilityChartFilter;
};
FbcApplicabilityChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FbcApplicabilityChartFilterFactory;